import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import { ToastProvider } from "./contexts/ToastContext";
import SEO from "./components/SEO";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Features from "./components/Features";
import HowItWorks from "./components/HowItWorks";
import Partners from "./components/Partners";
import Institutions from "./components/Institutions";
import Blog from "./components/Blog";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import AdminRoute from "./components/admin/AdminRoute";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <ToastProvider>
          <div className="relative min-h-screen transition-colors duration-300 bg-gradient-to-b from-white via-gray-50 to-white dark:from-[#0b0f19] dark:via-[#0a0d16] dark:to-[#0b0f19] overflow-x-hidden">
            {/* page-level soft radial glow */}
            <div className="pointer-events-none absolute inset-0 [background:radial-gradient(60%_40%_at_50%_0%,rgba(233,92,73,0.10),transparent_60%)] dark:[background:radial-gradient(60%_40%_at_50%_0%,rgba(233,92,73,0.16),transparent_60%)]" />
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/admin" element={<AdminRoute />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
            </Routes>
          </div>
        </ToastProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}

function LandingPage() {
  return (
    <>
      <SEO />
      <Header />
      <main className="relative">
        <Hero />
        <Features />
        <HowItWorks />
        <Partners />
        <Institutions />
        <Blog />
        <CTA />
      </main>
      <Footer />
    </>
  );
}

export default App;
